import React__default, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import sharedEN from './translate/shared_en.json.js';
import sharedES from './translate/shared_es.json.js';
import systemEN from './translate/system_en.json.js';
import systemES from './translate/system_es.json.js';

const useTranslate = ()=>{
    const translate = useTranslation();
    return translate.t;
};
const useLocale = ()=>{
    const translate = useTranslation();
    const locale = useMemo(()=>{
        let locale = "en-US";
        if (!!translate.i18n.language && translate.i18n.language.startsWith("es")) {
            locale = "es-US";
        }
        return locale;
    }, []);
    return locale;
};
const TranslateProvider = (props)=>{
    const translate = useTranslation();
    translate.i18n.addResourceBundle("en", "system", systemEN);
    translate.i18n.addResourceBundle("es", "system", systemES);
    // For now, all translation strings are bundled into the happy design translation provider... this is a bit of coupling
    // that is required between the shared packages and the system package (for now, ideally will be seperated in future)
    translate.i18n.addResourceBundle("en", "shared", sharedEN);
    translate.i18n.addResourceBundle("es", "shared", sharedES);
    return React__default.createElement(React__default.Fragment, null, props.children);
};
const useHasI18NextContext = ()=>{
    const translate = useTranslation();
    return translate.i18n.isInitialized;
};

export { TranslateProvider, useHasI18NextContext, useLocale, useTranslate };
